/** Screen-PRO08X guest sandbox session keys and voice binding */

export const GUEST_SESSION_ID_KEY = 'mentology.guestSessionId';
export const PENDING_GUEST_TRANSCRIPT_KEY = 'pending_guest_transcript';
export const STRESS_TEST_FROM_KEY = 'mentology.stressTestConversion';

/** Dr. André Smit Socratic Mentor — cloned voice for PRO08X */
export const STRESS_TEST_VOICE_ID = '3PAGrGiO5ZE62Ug1XOss';

export const STRESS_TEST_FOCUS_AREAS = [
  { id: 'pricing', label: 'Pricing / Margin' },
  { id: 'scaling', label: 'Talent / Scaling' },
  { id: 'capital', label: 'Capital / Product' },
] as const;

export type StressTestFocusId = (typeof STRESS_TEST_FOCUS_AREAS)[number]['id'];

export interface GuestTranscriptMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
}

export function getOrCreateGuestSessionId(): string {
  let id = sessionStorage.getItem(GUEST_SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(GUEST_SESSION_ID_KEY, id);
  }
  return id;
}

export function savePendingGuestTranscript(messages: GuestTranscriptMessage[]): void {
  sessionStorage.setItem(PENDING_GUEST_TRANSCRIPT_KEY, JSON.stringify(messages));
  sessionStorage.setItem(STRESS_TEST_FROM_KEY, '1');
}

export function loadPendingGuestTranscript(): GuestTranscriptMessage[] | null {
  const raw = sessionStorage.getItem(PENDING_GUEST_TRANSCRIPT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as GuestTranscriptMessage[];
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function clearPendingGuestTranscript(): void {
  sessionStorage.removeItem(PENDING_GUEST_TRANSCRIPT_KEY);
  sessionStorage.removeItem(STRESS_TEST_FROM_KEY);
}

export function isStressTestConversion(): boolean {
  return sessionStorage.getItem(STRESS_TEST_FROM_KEY) === '1';
}
